import Loader from "../../../components/Loader/Loader";
import Form from "../../../components/Form/Form";
import React, { useEffect, useState } from "react";
import Input from "../../../components/Input/Input";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { useUserStore } from "../../../contexts/userStore";
import { ReaderModel, ReaderModelEnum } from "../../../constants/readers-model";
import ReadersService from "../../../services/ReadersService";
import { useSSEContext } from "../../../contexts/sse";
import { IoAlertCircleOutline } from "react-icons/io5";

export function ConfigSemParar(props) {
   const [showLoader, setShowLoader] = useState(false);
   const { selectedCondominio, selectedCondominioObj, selectedLicenceId } = useUserStore();
   const [port, setPort] = useState();
   const [unitName, setUnitName] = useState(selectedCondominioObj?.name);
   const [integratorCode, setIntegratorCode] = useState();
   const [localCode, setLocalCode] = useState();
   const [prefixesTags, setPrefixesTags] = useState();
   const [timeExitAntenna, setTimeExitAntenna] = useState(3000);
   const [enabled, setEnabled] = useState(false);
   const [status, setStatus] = useState();
   const { sseReceived } = useSSEContext();

   function updateConfig(config) {
      setPort(config.port ?? 9091);
      setEnabled(config.enabled);
      setUnitName(config.configuration.unitName);
      setIntegratorCode(config.configuration.integratorCode);
      setLocalCode(config.configuration.localCode);
      setPrefixesTags(config.configuration.prefixesTags);
      setTimeExitAntenna(config.configuration.timeExitAntenna);
      setStatus(config?.status);
   }

   useEffect(() => {
      if (sseReceived?.action === 'serviceConfigUpdate' && sseReceived?.content?.model === ReaderModelEnum.SEM_PARAR) {
         updateConfig(sseReceived.content);
      }
   }, [sseReceived]);

   async function fetchConfig() {
      const response = await ReadersService.getReaderServiceConfig(ReaderModelEnum.SEM_PARAR, selectedCondominio, selectedLicenceId);
      const config = response.data;
      updateConfig(config);
   }

   useEffect(() => {
      if (selectedCondominio) {
         fetchConfig();
      }
   }, [selectedCondominio]);

   async function handleSubmit(event) {
      event.preventDefault();
      const payload = {
         port,
         enabled,
         configuration: {
            unitName,
            integratorCode,
            localCode,
            prefixesTags,
            timeExitAntenna,
         }
      }
      await ReadersService.updateReaderServiceConfig(ReaderModelEnum.SEM_PARAR, selectedCondominio, selectedLicenceId, payload);
   }

   return (
      <React.Fragment>
         {showLoader ? (
            <Loader />
         ) : (
            <Form
               handleSubmit={handleSubmit}
               type={props.type}
               navigateCancelUrl="../consulta-readers"
            >
               {status === 'notSynced' && (
                  <div className='alert alert-warning'>
                     <IoAlertCircleOutline size={20} />
                     <span><b>Atenção:</b> O serviço para os dispositivos {ReaderModel.SEM_PARAR.name} não está sincronizado com o equipamento, os eventos do dispositivo não serão recebidos e processados!</span>
                     <a href="void(0)" onClick={e => handleSubmit(e)}>Sincronizar</a>
                  </div>
               )}
               {status != null && !['notSynced', 'synced'].includes(status) && (
                  <div className='alert alert-danger'>
                     <IoAlertCircleOutline size={20} />
                     <span><b>Atenção:</b> A sincronização do serviço para os dispositivos {ReaderModel.SEM_PARAR.name} registrou um erro, os eventos do dispositivo não serão recebidos e processados!</span>
                     <a href="void(0)" onClick={e => handleSubmit(e)}>Sincronizar</a>
                  </div>
               )}
               <div className="grid grid-cols-2 w-full gap-3">
                  <Input
                     name="port"
                     id="port"
                     type="number"
                     labelText="Porta de Serviço TCP"
                     value={port}
                     onChange={({ target }) => setPort(target.value)}
                     required={true}
                  />
                  <Input
                     name="unitName"
                     id="unitName"
                     labelText="Nome do Local"
                     value={unitName}
                     onChange={({ target }) => setUnitName(target.value)}
                     required={true}
                  />
                  <Input
                     name="integratorCode"
                     id="integratorCode"
                     labelText="Código de Integrador"
                     value={integratorCode}
                     onChange={({ target }) => setIntegratorCode(target.value)}
                     required={true}
                  />
                  <Input
                     name="localCode"
                     id="localCode"
                     labelText="Código de Local"
                     value={localCode}
                     onChange={({ target }) => setLocalCode(target.value)}
                     required={true}
                  />
                  <Input
                     name="prefixesTags"
                     id="prefixesTags"
                     labelText="Prefixos Tags Sem Parar"
                     value={prefixesTags}
                     onChange={({ target }) => setPrefixesTags(target.value)}
                  />
                  <Input
                     name="timeExitAntenna"
                     id="timeExitAntenna"
                     type="number"
                     labelText="Tempo Exit Antena (ms)"
                     value={timeExitAntenna}
                     onChange={({ target }) => setTimeExitAntenna(target.value)}
                  />
                  <ToggleButton
                     style={{ width: 'fit-content', paddingTop: '15px' }}
                     label={`Habilitado`}
                     onChange={(e) => setEnabled(e.target.checked)}
                     selected={enabled}
                  />
               </div>
            </Form>
         )}
      </React.Fragment>
   );
}